import type { DealProductWithLocation } from "@/models/deal/deal.types";
import type { ProductEligibility, ProductType } from "@/models/product";

export function filterEligibleWindows(
    products: DealProductWithLocation[],
    eligibilityByProductId: Record<string, ProductEligibility>,
    category: ProductType | null,
): DealProductWithLocation[] {
    if (category === null) return products;

    const field: keyof ProductEligibility =
        category === "WINDOW_DECORATION"
            ? "eligibleForWindowDecoration"
            : "eligibleForSunProtection";

    return products.filter(
        (product) =>
            eligibilityByProductId[product.productId]?.[field] === true,
    );
}
